import styled, { css, keyframes } from "styled-components";

const revealPetal = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

const revealLabel = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

export const Container = styled.div<{ isExiting?: boolean }>`
    background-color: #faf9f5;
    animation: ${({ isExiting }) => isExiting ? fadeOut : "none"} 0.5s ease forwards;
`;

export const Background = styled.div`
    background-color: #FBF1EA;
`;

export const Header = styled.p`
    margin: 0px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 14px;
    margin-left: 12px;
    margin-right: 12px;
    @media (min-width: 1440px) { 
        font-size: 20px;
    }
`;

export const AnalyseTitle = styled.h1`
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    padding-top: 25px;
    color: var(--color-coal-50);
    margin-bottom: 8px;
    font-weight: 500;
    @media (min-width: 1440px) {
        font-size: 18px;
    }
`;

export const LoaderShell = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 380px;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 768px) {
        width: 50%;
    }
    @media (min-width: 1024px) {
        width: 35%; 
    }
`;

export const LoaderSvg = styled.svg<{ animationRunning?: boolean }>`
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    overflow: visible;

    .petal {
        opacity: 0;
        ${({ animationRunning }) => animationRunning ? css`animation: ${revealPetal} 1.0s ease forwards;` : ""}
    }

    .petal-1 {
        animation-delay: 0.2s;
    }

    .petal-2 {
        animation-delay: 1.1s;
    }

    .petal-3 {
        animation-delay: 2.0s;
    }

    .petal-4 {
        animation-delay: 2.9s;
    }

    .petal-5 {
        animation-delay: 3.8s;
    }

    .petal-label {
        opacity: 0;
        font-size: 4px;
        text-anchor: middle;
        dominant-baseline: middle;
        ${({ animationRunning }) => animationRunning ? css`animation: ${revealLabel} 0.9s ease forwards;` : ""}
    }

    .label-1 {
        fill: #BCD4B6;
        animation-delay: 0.2s;
    }

    .label-2 {
        fill: #B0C5D8;
        animation-delay: 1.1s;
    }

    .label-3 {
        fill: #C5BDD9;
        animation-delay: 2.0s;
    }

    .label-4 {
        fill: #DEC894;
        animation-delay: 2.9s;
    }

    .label-5 {
        fill: #E7BDB3;
        animation-delay: 3.8s;
    }

`;

export const loaderRow = styled.div`
    position: relative;
    margin: -30px auto 0;
`;

export const DotRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 7px;
    padding-bottom: 20px;
`;

export const DotItem = styled.span<{ animationRunning?: boolean }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    opacity: 0;
    ${({ animationRunning }) => animationRunning ? css`animation: ${revealLabel} 0.7s ease forwards;` : ""}

    &.dot-1 {
        animation-delay: 0.2s;
        background-color: #BCD4B6;
    }

    &.dot-2 {
        animation-delay: 1.1s;
        background-color: #B0C5D8;
    }

    &.dot-3 {
        animation-delay: 2.0s;
        background-color: #C5BDD9;
    }

    &.dot-4 {
        animation-delay: 2.9s;
        background-color: #DEC894;
    }

    &.dot-5 {
        animation-delay: 3.8s;
        background-color: #E7BDB3;
    }
`;

export const Logo = styled.img`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: auto;
    z-index: 2;
    @media (min-width: 1440px) {
        width: 60px;
        margin-left: auto;
        margin-right: auto; 
    }
`; 
